export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6305.eb8d1796.jpg";